export function mergeDateCellRender(options) {
    const { prefixCls, generateConfig, dateRender, cellRender, cellRenderSlot } = options;
    if (dateRender) {
        return dateRender;
    }
    if (!cellRender && !cellRenderSlot) {
        return undefined;
    }
    return ({ current, today }) => {
        const originNode = (<div class={`${prefixCls}-cell-inner`}>{generateConfig.getDate(current)}</div>);
        const info = {
            originNode,
            today,
            type: 'date',
        };
        if (cellRender) {
            return cellRender(current, info);
        }
        return cellRenderSlot(Object.assign({ current }, info));
    };
}
export function mergeMonthCellRender(options) {
    const { prefixCls, generateConfig, monthCellRender, cellRender, cellRenderSlot } = options;
    if (monthCellRender) {
        return monthCellRender;
    }
    if (!cellRender && !cellRenderSlot) {
        return undefined;
    }
    return ({ current, locale }) => {
        const months = locale.shortMonths ||
            (generateConfig.locale.getShortMonths
                ? generateConfig.locale.getShortMonths(locale.locale)
                : []);
        const originNode = (<div class={`${prefixCls}-cell-inner`}>{months[generateConfig.getMonth(current)]}</div>);
        const info = {
            originNode,
            type: 'month',
            locale,
        };
        if (cellRender) {
            return cellRender(current, info);
        }
        return cellRenderSlot(Object.assign({ current }, info));
    };
}
export function mergeRangeDateCellRender(options) {
    const { prefixCls, generateConfig, dateRender, cellRender, cellRenderSlot } = options;
    if (dateRender) {
        return dateRender;
    }
    if (!cellRender && !cellRenderSlot) {
        return undefined;
    }
    return ({ current, today, info: rangeInfo }) => {
        const originNode = (<div class={`${prefixCls}-cell-inner`}>{generateConfig.getDate(current)}</div>);
        const info = {
            originNode,
            today,
            type: 'date',
            range: rangeInfo === null || rangeInfo === void 0 ? void 0 : rangeInfo.range,
        };
        if (cellRender) {
            return cellRender(current, info);
        }
        return cellRenderSlot(Object.assign({ current }, info));
    };
}
